import axios from 'axios';
import { baseUrl } from './config';

export const setIsAdmin = async (_id: string, isAdmin: boolean) => {
    const url = `${baseUrl}/admin/user/${_id}/set-admin/${isAdmin}`;
    await axios.post(url);
};
